import SelectTimeSlot from "../../../component/SelectTimeSlot";
import { useEffect, useState } from "react";
import SelectAddress from "../../../component/SelectAddress";
import moment from "moment";
import { useDispatch } from "react-redux";
import {
  endRideRequest,
  getBookingDetailsById,
  getCurrentBooking,
} from "../../../redux/actions/rentActions/bookingAction";
import { getHomeDeliverCharge } from "../../../redux/actions";
import "../../../css/global.css";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/reducers";
import { toastr } from "react-redux-toastr";
import { MitcFormsSkelaton } from "../../../component/SkelatonLoader/MitcFormsSkelaton";
import { FirebaseEvents } from "../../../utills/firebaseEvents";
const DEFAULT_DATA = {
  mode: 1,
  location_id: null,
  time_slot: null,
  homepickUpCharge: null,
};

const EndRideModal = ({
  onHide,
  bookingDetailsById,
  packageMaster,
  callOrderApi,
}: any) => {
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const [endRideData, setEndRideData] = useState<any>(DEFAULT_DATA);
  const [deliveryChargeLoader, setDeliveryChargeLoader] =
    useState<boolean>(true);
  const { homeDeliverCharges } = useSelector(
    (state: RootState) => state.checkoutReducer
  );

  const {
    id,
    booking_id,
    bike_name,
    rental_days,
    status,
    branch_id,
    branch_name,
    pickup_location,
    city_id,
  } = bookingDetailsById;


  const handleChange = (key: any, value: any, cityid: any) => {
    const data = { ...endRideData };
    data[key] = value;
    setEndRideData(data);
    if (endRideData?.mode && key == 'location_id') {
      let payload = { city_id: cityid ?? 0, branch_id: branch_id };
      dispatch(getHomeDeliverCharge(payload, setDeliveryChargeLoader));
    }
  };
  const handleTimeSlot = (timeSlot: any) => {
    handleChange("time_slot", timeSlot, "");
  };
  const handleQuery = () => {
    setLoader(true);
    const payload: any = {
      time_slot_id: Number(endRideData?.time_slot?.id) || null,
      mode_of_drop_off_id: Number(endRideData.mode),
      pick_address_id: Number(endRideData?.location_id) || null,
    };
    if (endRideData?.mode == 1)
      payload.delivery_charge = homeDeliverCharges?.home_delivery_charge;
    console.log("EndRideRequest", {
      time:
        endRideData?.time_slot?.from_time +
        "-" +
        endRideData?.time_slot?.to_time,
      type: endRideData?.mode == 2 ? "Drop-off Vehicle" : "Home Pick-up",
    });
    FirebaseEvents("EndRideRequest", {
      time:
        endRideData?.time_slot?.from_time +
        "-" +
        endRideData?.time_slot?.to_time,
      type: endRideData?.mode == 2 ? "Drop-off Vehicle" : "Home Pick-up",
    });
    dispatch(endRideRequest(id, payload, handleSuccess, setLoader));
  };
  const hideModal = () => {
    setLoader(false);
    onHide((prev) => ({ ...prev, endRide: false }));
  };
  const handleSuccess = (response) => {
    if (response?.amount > 0) {
      callOrderApi(
        response?.amount,
        response?.helpData?.payment_purpose_id,
        response?.helpData,
        hideModal
      );
    } else {
      hideModal();
      toastr.success("Success", "End ride request raised!");
      setTimeout(() => {
        window.location.reload();
      }, 500);
    }
  };
  const stopLoader = () => setLoader(false);

  const isDisabled = () => {
    const { mode, location_id, time_slot } = endRideData;
    return time_slot?.id && (mode == 2 || location_id);
  };

  // useEffect(() => {
  //   if (endRideData?.mode) {
  //     let payload = { city_id: city_id ? city_id : 0, branch_id: branch_id };
  //     dispatch(getHomeDeliverCharge(payload, setDeliveryChargeLoader));
  //   }
  // }, []);
  useEffect(() => {}, [homeDeliverCharges]);
  return (
    <div
      className="modal end-ride-wrapper fade backdrop show"
      id="EndrideModal"
      tabIndex={-1}
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header custom-modal">
            <h5>End Ride</h5>
            <button
              type="button"
              className="btn-close"
              onClick={() => onHide((prev) => ({ ...prev, endRide: false }))}
            ></button>
          </div>
          <div className="modal-body text-start mt-3">
            <div className="extent-ride-body-wrap ">
              <div className="extent-ride-details ">
                <p>
                  Booking ID: <span className="idbook">{booking_id}</span>
                </p>
              </div>
              <div className="extent-ride-details">
                <p>
                  {" "}
                  Vehicle Name: <span>{bike_name}</span>
                </p>
              </div>
              <div className="extent-ride-details ">
                <p>
                  {" "}
                  Previous Package: <span>{rental_days} Rental</span>
                </p>
              </div>
              <div className="extent-ride-details">
                <p>
                  {" "}
                  Status: <span className="status-ongoing">{status}</span>
                </p>
              </div>
            </div>

            <div className="mode-wrap">
              <h6>Mode Of Drop-Off</h6>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault1"
                  value={1}
                  defaultChecked
                  onChange={(e) => {
                    setEndRideData({
                      ...DEFAULT_DATA,
                      mode: e.target.value,
                    });
                  }}
                />
                <label className="form-check-label" htmlFor="flexRadioDefault1">
                  Home Pick-Up
                </label>
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault2"
                  value={2}
                  onChange={(e) =>
                    setEndRideData({
                      ...DEFAULT_DATA,
                      mode: e.target.value,
                    })
                  }
                />
                <label className="form-check-label" htmlFor="flexRadioDefault2">
                  Vehicle Drop-Off
                </label>
              </div>
              {
                <h3>
                  {" "}
                  {deliveryChargeLoader ? (
                    <MitcFormsSkelaton />
                  ) : endRideData?.mode == 1 &&
                    homeDeliverCharges?.home_delivery_charge ? (
                    <p className="applicable-info mt-2">
                      <span>*</span>{" "}
                      {`Applicable Home Pickup Charges  ₹    ${Math.round(homeDeliverCharges?.home_delivery_charge)}`}
                    </p>
                  ) : (
                    ""
                  )}
                </h3>
              }
            </div>

            {endRideData.mode == 1 ? (
              <>
                <SelectAddress
                  timeSlotDetail={endRideData}
                  handleChange={handleChange}
                  homePickupCharge={homeDeliverCharges?.home_delivery_charge}
                />
              </>
            ) : (
              <div className="mt-3">
                <h6>Drop-off location</h6>
                <p className="mt-1">{branch_name}</p>
              </div>
            )}
            <SelectTimeSlot
              handleChange={handleTimeSlot}
              filterData={{
                date: moment().format("YYYY-MM-DD"),
                branch_id: branch_id,
                option_id: endRideData.mode == 1 ? 2 : 3,
              }}
            />
            <div className="end-ride-bottom text-center mt-2">
              <button
                onClick={handleQuery}
                className="freedo-primary-button rounded-pill"
                disabled={!isDisabled()}
              >
                {loader ? (
                  <>
                    <div
                      className="spinner-border spinner-border-sm text-light"
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </>
                ) : (
                  <>{"Raise Request"}</>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default EndRideModal;
